import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "motion/react";
import { supabase } from "../lib/supabaseClient";
import { adminStyles } from "./adminStyles";

export default function AdminLoginPage({
                                           kennelName = "Havaneser-Zucht",
                                           primaryColor = "#8b5e3c",
                                           secondaryColor = "#b9835a",
                                       }) {
    const navigate = useNavigate();

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    const handleSubmit = async (event) => {
        event.preventDefault();

        setIsSubmitting(true);
        setErrorMessage("");

        const { error } = await supabase.auth.signInWithPassword({
            email,
            password,
        });

        setIsSubmitting(false);

        if (error) {
            setErrorMessage("Login fehlgeschlagen. Bitte E-Mail und Passwort prüfen.");
            return;
        }

        navigate("/admin", { replace: true });
    };

    return (
        <main style={adminStyles.page}>
            <motion.form
                style={adminStyles.card}
                onSubmit={handleSubmit}
                initial={{ opacity: 0, y: 24 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.45 }}
            >
                <h1 style={{ ...adminStyles.title, color: primaryColor }}>
                    Admin Login
                </h1>

                <p style={adminStyles.subtitle}>
                    Melden Sie sich an, um Neuigkeiten und Inhalte für {kennelName} zu verwalten.
                </p>

                <div style={{ height: "1.75rem" }} />

                {errorMessage && <div style={adminStyles.error}>{errorMessage}</div>}

                <div style={adminStyles.field}>
                    <label style={adminStyles.label} htmlFor="email">
                        E-Mail
                    </label>
                    <input
                        id="email"
                        type="email"
                        autoComplete="email"
                        value={email}
                        onChange={(event) => setEmail(event.target.value)}
                        style={adminStyles.input}
                        required
                    />
                </div>

                <div style={adminStyles.field}>
                    <label style={adminStyles.label} htmlFor="password">
                        Passwort
                    </label>
                    <input
                        id="password"
                        type="password"
                        autoComplete="current-password"
                        value={password}
                        onChange={(event) => setPassword(event.target.value)}
                        style={adminStyles.input}
                        required
                    />
                </div>

                <motion.button
                    type="submit"
                    style={{
                        ...adminStyles.button,
                        backgroundColor: primaryColor,
                        opacity: isSubmitting ? 0.75 : 1,
                    }}
                    whileHover={{
                        scale: isSubmitting ? 1 : 1.03,
                        backgroundColor: secondaryColor,
                    }}
                    whileTap={{ scale: isSubmitting ? 1 : 0.97 }}
                    disabled={isSubmitting}
                >
                    {isSubmitting ? "Wird angemeldet..." : "Einloggen"}
                </motion.button>
            </motion.form>
        </main>
    );
}